import { getJSON } from './http';

/** One live event (goal / card / substitution / VAR). Mirrors `eventView`. */
export type MatchEvent = {
  id: number;
  teamCode: string;
  eventType: string; // "Goal" | "Card" | "subst" | "Var" | ...
  minute: number;
  minuteExtra?: number;
  playerName: string;
  relatedPlayer?: string;
  meta?: Record<string, unknown>;
  source: string;
};

/** Per-team aggregate stats. All fields optional — providers vary. */
export type MatchStat = {
  teamCode: string;
  shotsTotal?: number;
  shotsOn?: number;
  shotsOff?: number;
  shotsBlocked?: number;
  corners?: number;
  offsides?: number;
  fouls?: number;
  possessionPct?: number;
  yellowCards?: number;
  redCards?: number;
  saves?: number;
  passesTotal?: number;
  passesAccurate?: number;
  passesPct?: number;
  xg?: number;
};

/** Enhanced match detail. Mirrors the backend `MatchDetailView`. */
export type MatchDetailView = {
  matchNumber: number;
  phase: string;
  group?: string;
  kickoffUtc: string;
  status: 'upcoming' | 'live' | 'done' | 'cancelled';
  minute?: number;
  teamA?: string;
  teamB?: string;
  scoreA?: number;
  scoreB?: number;
  scoreAHt?: number;
  scoreBHt?: number;
  scoreAEt?: number;
  scoreBEt?: number;
  scoreAPens?: number;
  scoreBPens?: number;
  events: MatchEvent[];
  stats?: MatchStat[];
};

export type TvLink = {
  id: number;
  channel: string;
  region?: string;
  language?: string;
  note?: string;
  url?: string;
  isFree: boolean;
  sortOrder: number;
};

/** GET /api/tournaments/{code}/matches/{n} — public enhanced detail. */
export function fetchMatchDetail(n: number, code = 'wc2026'): Promise<MatchDetailView> {
  return getJSON(`/api/tournaments/${code}/matches/${n}`);
}

/** GET /api/matches/{n}/tv-links — broadcast channels (WC2026). */
export async function fetchTvLinks(n: number): Promise<TvLink[]> {
  const body = await getJSON<{ links?: TvLink[] }>(`/api/matches/${n}/tv-links`);
  return body.links ?? [];
}
